import React from 'react';

export const pendingTaskConfig = [
  {
    path: '/pending-task',
    component: React.lazy(() => import('./pendingTaskMainScreen')),
  },
  {
    path: '/pending-task/user-management',
    component: React.lazy(() => import('./detail/userManagement')),
  },
  {
    path: '/pending-task/update-company',
    component: React.lazy(() => import('./detail/updateCompany')),
  },
  {
    path: '/pending-task/order-cash-pick-up',
    component: React.lazy(() => import('./detail/orderCashPickUp/detail')),
  },
  {
    path: '/pending-task/cpc-vaulting-cash-pick-up',
    component: React.lazy(() =>
      import('./detail/cpcVaultingCashPickUp/detail'),
    ),
  },
  {
    path: '/pending-task/overview-cpc-vaulting-cash-pick-up',
    component: React.lazy(() =>
      import('./detail/cpcVaultingCashPickUp/view/view'),
    ),
  },
  {
    path: '/pending-task/penanganan-uang-diragukan',
    component: React.lazy(() => import('./detail/uangDiragukan/detail')),
  },
  {
    path: '/pending-task/penanganan-uang-diragukan/overview-surat-klarifikasi',
    component: React.lazy(() =>
      import('./detail/uangDiragukan/overviewKlarifikasi/overviewKlarifikasi'),
    ),
  },
  {
    path: '/pending-task/penanganan-uang-diragukan/overview-surat-tanggapan',
    component: React.lazy(() =>
      import('./detail/uangDiragukan/overviewTanggapan/overviewTanggapan'),
    ),
  },
  {
    path: '/pending-task/order-cash-pick-up-sortasi',
    component: React.lazy(() =>
      import('./detail/orderCashPickUpSortasi/detail'),
    ),
  },
  {
    path: '/pending-task/order-cash-pick-up-sortasi/confirmation-sorting',
    component: React.lazy(() =>
      import(
        './detail/orderCashPickUpSortasi/repair/confirmationOfSortingResults/confirmationOfSortingResults'
      ),
    ),
  },
  {
    path: '/pending-task/order-cash-pick-up-sortasi/difference-confirmation',
    component: React.lazy(() =>
      import(
        './detail/orderCashPickUpSortasi/repair/differenceConfirmation/differenceConfirmation'
      ),
    ),
  },
  {
    path: '/pending-task/order-cash-pick-up-sortasi/overview-sorting',
    component: React.lazy(() =>
      import(
        './detail/orderCashPickUpSortasi/repair/overviewOfSortingResults/overviewOfSortingResults'
      ),
    ),
  },
  {
    path: '/pending-task/order-cash-delivery',
    component: React.lazy(() => import('./detail/orderCashDelivery/detail')),
  },
  {
    path: '/pending-task/cpc-maker',
    component: React.lazy(() => import('./detail/cpcMaker/detail')),
  },
  {
    path: '/pending-task/order-cash-movement',
    component: React.lazy(() => import('./detail/orderCashMovement/detail')),
    // component: React.lazy(() => import('./detail/orderCashPickUpSortasi/detail')),
  },
  {
    path: '/pending-task/service-cash-movement-noseal',
    component: React.lazy(() =>
      import('./detail/serviceCashMovementNoSeal/detail'),
    ),
  },
  {
    path: '/pending-task/service-cash-movement-noseal/overview-input-noseal',
    component: React.lazy(() =>
      import(
        './detail/serviceCashMovementNoSeal/repairComponent/inputSeal/overview/overview'
      ),
    ),
  },
  {
    path: '/pending-task/order-cash-replenishment',
    component: React.lazy(() =>
      import('./detail/orderCashReplineshment/detail'),
    ),
  },
  {
    path: '/pending-task/order-cash-replenishment-acceptance-no-seal',
    component: React.lazy(() =>
      import('./detail/cashReplenishmentAcceptNoSeal/detail'),
    ),
  },
  {
    path: '/pending-task/order-cash-replenishment-pembukuan',
    component: React.lazy(() =>
      import('./detail/orderCashReplenishmentPembukuan/index'),
    ),
  },
  {
    path: '/pending-task/order-cash-movement-acceptance-no-seal-overview',
    component: React.lazy(() =>
      import('./detail/serviceCashMovementNoSeal/overview/index'),
    ),
  },
  // {
  //   path: '/pending-task/sortation-cash-replenishment',
  //   component: React.lazy(() =>
  //     import('./detail/cashReplenishmentAcceptNoSeal/detail'),
  //   ),
  // },
  {
    path: '/pending-task/assign-pic',
    component: React.lazy(() => import('./detail/orderCashReturn/detail')),
    // component: React.lazy(() => import('./detail/orderCashPickUpSortasi/detail')),
  },
  {
    path: '/pending-task/input-no-seal',
    component: React.lazy(() =>
      import('./detail/orderCashReturnNoSeal/detail'),
    ),
    // component: React.lazy(() => import('./detail/orderCashPickUpSortasi/detail')),
  },
  {
    path: '/pending-task/cash-replenishment-uang-diragukan',
    component: React.lazy(() =>
      import('./detail/uangDiragukanReplenishment/detail'),
    ),
  },
  {
    path: '/pending-task/cash-replenishment-uang-diragukan/isi-surat-klarifikasi',
    component: React.lazy(() =>
      import(
        './detail/uangDiragukanReplenishment/overviewKlarifikasi/overviewKlarifikasi'
      ),
    ),
  },
  {
    path: '/pending-task/cash-replenishment-uang-diragukan/isi-surat-tanggapan',
    component: React.lazy(() =>
      import(
        './detail/uangDiragukanReplenishment/overviewTanggapan/overviewTanggapan'
      ),
    ),
  },
  {
    // component: React.lazy(() => import('./detail/orderCashPickUpSortasi/detail')),
    path: '/pending-task/repair-noseal-cash-movement',
    component: React.lazy(() =>
      import('./detail/repairNoSealCashMovement/detail'),
    ),
  },
  {
    path: '/pending-task/cpc-vaulting',
    component: React.lazy(() => import('./detail/cpcVaulting/detail')),
  },
  {
    path: '/pending-task/order-cash-replenishment-sortasi',
    component: React.lazy(() =>
      import('./detail/cashReplenishmentSortasi/detail'),
    ),
  },
  {
    path: '/pending-task/order-cash-replenishment-sortasi/confirmation-sorting',
    component: React.lazy(() =>
      import(
        './detail/cashReplenishmentSortasi/repair/confirmationOfSortingResults/confirmationOfSortingResults'
      ),
    ),
  },
  {
    path: '/pending-task/order-cash-replenishment-sortasi/difference-confirmation',
    component: React.lazy(() =>
      import(
        './detail/cashReplenishmentSortasi/repair/differenceConfirmation/differenceConfirmation'
      ),
    ),
  },
  {
    path: '/pending-task/order-cash-replenishment-sortasi/overview-sorting',
    component: React.lazy(() =>
      import(
        './detail/cashReplenishmentSortasi/repair/overviewOfSortingResults/overviewOfSortingResults'
      ),
    ),
  },
  {
    path: '/pending-task/vaulting-cash-movement',
    component: React.lazy(() => import('./detail/cpcVaulting/detail')),
  },
  {
    path: '/pending-task/repair-no-seal-cash-return',
    component: React.lazy(() => import('./detail/repairSealCashReturn/detail')),
  },
  {
    path: '/pending-task/repair-no-seal-overview',
    component: React.lazy(() =>
      import('./detail/cpcMaker/repair/repairSeal/overview'),
    ),
  },
  {
    path: '/pending-task/input-no-seal-overview',
    component: React.lazy(() =>
      import('./detail/cpcMaker/repair/inpurSeal/overview/detail'),
    ),
  },
  {
    path: '/pending-task/rincian-cash-return-pembukuan',
    component: React.lazy(() => import('./detail/cashReturnPembukuan/index')),
  },
  {
    path: '/pending-task/konfirmasi-denda-pengangkutan',
    component: React.lazy(() =>
      import('./detail/konfirmasiDendaPengangkutan/index'),
    ),
  },
  {
    path: '/pending-task/konfirmasi-denda-sortasi',
    component: React.lazy(() =>
      import('./detail/konfirmasiDendaSortasi/index'),
    ),
  },
  {
    path: '/pending-task/vaulting-repair-replenishment',
    component: React.lazy(() =>
      import(
        './detail/cashReplenishmentAcceptNoSeal/repairComponent/overview/index'
      ),
    ),
  },
  {
    path: '/pending-task/service-cash-movement-noseal/overview-cpc-repair-noseal',
    component: React.lazy(() =>
      import(
        './detail/serviceCashMovementNoSeal/repairNoSealComponent/overview/overviewRepairNoSealCashMovement'
      ),
    ),
  },
  {
    path: '/pending-task/repair-seal-no/overview',
    component: React.lazy(() =>
      import(
        './detail/repairSealCashReturn/repairNoSealComponent/overview/overviewRepairNoSealCashReturn'
      ),
    ),
  },
];
